import React from "react";
import usexAPI from "store/customHooks/usexAPI";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";

function ServiceMenuButton(props) {
    const { gotoServiceMenu } = props;
    const { ServiceUnit_A } = usexAPI();

    const handleClick = () => {
        gotoServiceMenu();
        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0000);
    };
    return (
        <li className="fl display_btn3" onClick={handleClick}>
            <button type="button" className="menu"></button>
        </li>
    );
}

export default ServiceMenuButton;
